import constants from '../constants/index';

const CohortActions = {
  requestCohortsSuccess: function(participants) {
    return {
      type: constants.REQUEST_COHORTS_SUCCESS,
      payload: {
        participants
      }
    };
  },

  requestCohortsFail: function() {
    return {
      type: constants.REQUEST_COHORTS_FAIL,
      payload: {

      }
    };
  },

  selectCohort: function(id, selected) {
    return {
      type: constants.SELECT_COHORT,
      payload: {
        id: id,
        selected: selected
      }
    };

  },
  unSelectCohorts: function() {
    return {
      type: constants.UNSELECT_COHORTS,
      payload: {}
    };
  }
};

export default CohortActions;


/** WEBPACK FOOTER **
 ** ./src/js/actions/cohort_actions.js
 **/